import { render, staticRenderFns } from "./dietdurationprice.vue?vue&type=template&id=f2275e12"
import script from "./dietdurationprice.vue?vue&type=script&lang=js"
export * from "./dietdurationprice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports